import React from "react";
import { Button } from "@mui/material";
import { useNitroStore } from "../../../../store/Store";
import TruckIconFO from "../../../../icons/TruckIconFO";
import RailIconFO from "../../../../icons/RailIconFO";
import "./mobileModeToggleGroup.css";

const MobileModeToggleGroup: React.FC = () => {
  const [currentMode, setMode] = useNitroStore((state) => [
    state.mode,
    state.setMode,
  ]);

  const handleModeToggle = (mode: "truck" | "rail") => {
    const newMode = mode === "truck" ? "TRUCK" : "RAIL";
    setMode(newMode);
  };

  return (
    <div className="mode-toggle-group" id="mobile-mode-toggle-group">
      <Button
        id="sub-footer-truck-mode-button"
        className={`${
          currentMode === "TRUCK" ? "active-truck" : ""
        } truck-mode-button`}
        sx={{
          minWidth: "auto",
          transition: "none",
          display: "flex",
          height: "30px",
          marginLeft: "8px",
          padding: "12px 16px",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid transparent",
          borderRadius: "10px",
          "&:hover": {
            transform: "scale(1.15)",
            backgroundColor: "transparent",
          },
        }}
        onClick={() => handleModeToggle("truck")}
      >
        <span
          style={{ transform: "scale(1.2)", display: "flex" }}
          id="truck-mode-icon-wrapper"
        >
          <TruckIconFO color={currentMode === "TRUCK" ? "#FFF" : "#38BDF8"} />
        </span>
      </Button>

      <Button
        id="rail-mode-button"
        className={`${
          currentMode === "RAIL" ? "active-rail" : ""
        } rail-mode-button`}
        sx={{
          minWidth: "auto",
          transition: "none",
          display: "flex",
          height: "30px",
          marginRight: "8px",
          padding: "12px 16px",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid transparent",
          borderRadius: "10px",
          "&:hover": {
            transform: "scale(1.15)",
            backgroundColor: "transparent",
          },
        }}
        onClick={() => handleModeToggle("rail")}
      >
        <span
          style={{ transform: "scale(1.2)", display: "flex" }}
          id="rail-mode-icon-wrapper"
        >
          <RailIconFO color={currentMode === "RAIL" ? "#FFF" : "#F97316"} />
        </span>
      </Button>
    </div>
  );
};

export default MobileModeToggleGroup;
